
import styles from "./styles.module.css"



import { IoPricetags } from "react-icons/io5"

import { useState } from "react"
import { doc, updateDoc } from 'firebase/firestore'
import { database } from "../../../services/firebase-config"
import Loading from "../../Loading"


export default function BookMakeFreeButton({ collection, bookId, isVirtual, updateTableData }) {

    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    async function freeBook(docCollection, docId) {
        setIsLoading(true);
        const documentRef = doc(database, docCollection, docId);
        await updateDoc(documentRef, { free: true })
        setModal(false);
        setIsLoading(false);
        updateTableData();
    }


    return (<>
        <button title="Tornar gratuito" className={styles.removeButton} onClick={() => { setModal(true) }}>
            <IoPricetags />
        </button>

        {modal &&
            <div className={styles.modalContainer}>
                <div className={styles.modalCard}>
                    {isLoading && <Loading />}
                    <h2 className={styles.modalCard__title}>Deixar Gratuito</h2>
                    <p className={styles.modalCard__alert}>Tem certeza que deseja deixar este item <strong>Gratuito</strong> ?</p>
                    <div className={styles.modalCard__buttonsContainer}>
                        <button onClick={() => { setModal(false) }} className={styles.modalCard__closeButton}>Fechar</button>
                        <button onClick={() => { freeBook(collection, bookId) }} className={styles.modalCard__deleteButton}>Confirmar</button>
                    </div>
                </div>
            </div>
        }

    </>);
}